// MATM-1269 (RN-prep Stage 1a): the flag that enables the NON-BLOCKING
// background-OTA boot path in localAppShim.js.
//
// Extracted into its own dependency-free module so the resolver can be unit
// tested without pulling localAppShim's heavy Capacitor / BootAnim imports.
//
// DEFAULT OFF — when off, localAppShim's existing synchronous reachability-check
// + redirect path runs byte-for-byte unchanged, so there is no behavior change on
// any shipped bundle. The actual bundle-swap fix (serve the baked local bundle +
// apply a fetched update on next launch, replacing the remote-redirect model) is
// device-tested work tracked separately in bctask_rtojiqsrqdz8rfxqdnkrxr8vm.

// localStorage key QA can set to opt a device into the background-OTA path.
export const BACKGROUND_OTA_STORAGE_KEY = '@rubber/background-ota';

// Matches `_backgroundOta=1` or `_backgroundOta=true` anywhere in a URL/query.
const BACKGROUND_OTA_URL_RE = /[?&]_backgroundOta=(1|true)\b/i;

/**
 * Resolves whether the non-blocking background-OTA boot path is enabled.
 * DEFAULT OFF. Sources (first truthy wins), chosen so QA can flip it on a REAL
 * device build without recompiling:
 *   - URL param `_backgroundOta` (e.g. `?_backgroundOta=1`)
 *   - localStorage key `@rubber/background-ota` set to '1' or 'true'
 *
 * Kept dependency-free and side-effect-free so it is safe on the hot boot path.
 *
 * @param {string} [currentUrl] URL to inspect for the `_backgroundOta` param
 * @returns {boolean} true if the background-OTA path should be used
 */
export function isBackgroundOtaEnabled(currentUrl = '') {
	try {
		if (BACKGROUND_OTA_URL_RE.test(`${currentUrl}`)) {
			return true;
		}

		// `window` may be undefined in SSR/tests, and localStorage can throw in
		// locked-down web views — both cases fall through to OFF below.
		const stored =
			typeof window !== 'undefined'
				? window.localStorage?.getItem(BACKGROUND_OTA_STORAGE_KEY)
				: undefined;

		return stored === '1' || stored === 'true';
	} catch (ex) {
		// Fail safe to OFF on any access error.
		return false;
	}
}
